import React, { useEffect, useContext, useState } from 'react';
import { decodeBase64 } from './encodeBase64';
import { ContextUserProfile } from '../contexts/UserProfileContext';
import api, { cachedApi, setAxiosToken } from '../services/api';
import { tokenKey, rolKey, webTokenKey } from './authHelpers';
import {
    IdHotelOwnerKey,
    usernameKey,
    sidKey,
} from './userProfileContextHelpers';
import routes from './commonVariables/routes';
import { useAuth } from '../contexts/AuthContext';
import BunnyLoading from '../components/BunnyLoading';
import { Redirect } from 'react-router-dom';

const RedirectToOwnerPortal = ({ match }) => {
    const { setIdSystemUser, setIdHotelOwner, setUsername } =
        useContext(ContextUserProfile);
    const { handleIsAuthenticated, handleSaveToken } = useAuth();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        const objectParams = match.params;
        const {
            token: tokenUrlParams,
            webToken: webTokenUrlParams,
            sid,
            rol,
            IdHotelOwner: IdHotelOwnerUrlParams,
            encodedUsername,
        } = objectParams;
        localStorage.setItem(tokenKey, tokenUrlParams);
        localStorage.setItem(webTokenKey, webTokenUrlParams);
        localStorage.setItem(sidKey, sid);
        localStorage.setItem(rolKey, decodeBase64(rol));
        localStorage.setItem(IdHotelOwnerKey, IdHotelOwnerUrlParams);
        localStorage.setItem(usernameKey, decodeBase64(encodedUsername));
        setAxiosToken(cachedApi, tokenUrlParams);
        setAxiosToken(api, tokenUrlParams);
        setIdSystemUser(sid);
        setIdHotelOwner(IdHotelOwnerUrlParams);
        handleSaveToken(tokenUrlParams);
        handleIsAuthenticated(true);
        setUsername(decodeBase64(encodedUsername));
        setLoading(false);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return loading ? (
        <div className='App'>
            <BunnyLoading />
        </div>
    ) : (
        <Redirect to={routes.landingPrivate} />
    );
};

export default RedirectToOwnerPortal;
